import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/index.js';

export const LandingNavbar: React.FC = () => {
  return (
    <header className="sticky top-0 z-30 bg-base-100/85 backdrop-blur-md border-b border-base-300">
      <div className="max-w-[1248px] mx-auto h-14 md:h-16 flex items-center gap-6 md:gap-8 px-4 md:px-6">
        {/* Brand Logo & Name */}
        <Link to="/" className="flex items-center gap-2.5 min-h-11 text-base-content no-underline shrink-0">
          <img
            src="/icon.svg"
            alt="FretBoard"
            className="size-7.5 md:size-8 rounded-[9px] object-cover"
          />
          <span className="text-base md:text-[17px] font-extrabold tracking-tight" dir="ltr">
            FretBoard
          </span>
        </Link>

        {/* Nav Anchors (Desktop only) */}
        <nav aria-label="بخش‌های صفحه" className="hidden md:flex items-center gap-6 text-sm font-medium text-base-content/80">
          <a href="#features" className="hover:text-base-content transition-colors">امکانات</a>
          <a href="#focus" className="hover:text-base-content transition-colors">حالت تمرکز</a>
          <a href="#offline" className="hover:text-base-content transition-colors">آفلاین</a>
        </nav>

        {/* Spacer */}
        <div className="flex-1" />

        {/* Actions */}
        <div className="flex items-center gap-3">
          <Link
            to="/auth?mode=login"
            data-testid="landing-login-link"
            className="h-11 md:h-10 min-w-11 justify-center px-3 md:px-0 text-sm font-semibold text-base-content/80 hover:text-base-content transition-colors inline-flex items-center"
          >
            ورود
          </Link>
          <Button
            variant="primary"
            size="md"
            href="/auth?mode=register"
            className="h-10 md:h-10 px-3.5 md:px-[18px] rounded-xl text-sm font-semibold"
          >
            <span className="hidden sm:inline">شروع رایگان</span>
            <span className="sm:hidden">شروع</span>
          </Button>
        </div>
      </div>
    </header>
  );
};
